import type { OdooVendor, PaginatedOdooVendors } from '@/types/odooVendor';
import apiClient from './axios';

export async function fetchOdooVendors(limit: number, offset: number, search?: string): Promise<PaginatedOdooVendors> {
  const { data } = await apiClient.get<PaginatedOdooVendors>('/odoo/vendors', {
    params: { limit, offset, ...(search ? { search } : {}) },
    skipGlobalError: true,
  });
  return data;
}

export async function fetchOdooVendorById(id: number): Promise<OdooVendor> {
  const { data } = await apiClient.get<OdooVendor>(`/odoo/vendors/${id}`, { skipGlobalError: true });
  return data;
}
